import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Link, Checkbox, FormControlLabel, IconButton, InputAdornment } from '@mui/material';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import { LoginOperation, googleSignin } from '../../services/apiService';
import { showToast } from '../Toast/CommonToast';
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";


function Login() {
    // Show error message from URL param if present
    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const message = params.get("message");
        if (message) {
            showToast(decodeURIComponent(message), "error");
        }
    }, []);
    const navigate = useNavigate();
    const [email, setEmail] = useState<string>(""); // Define email state
    const [password, setPassword] = useState<string>(""); // Define password state
    const [errors, setErrors] = useState<any>({ email: "", password: "" }); // Define errors state
    const [showPassword, setShowPassword] = useState(false);
    const [loginError, setLoginError] = useState(""); // General login error
    // const desktop = window.innerWidth > 1440;
    
    const handleValidation = () => {
        let isValid = true;
        let newErrors = { email: "", password: "" };
    
        if (!email) {
          newErrors.email = "Please enter your email";
          isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
          newErrors.email = "Invalid email format";
          isValid = false;
        }
    
        if (!password) {
          newErrors.password = "Please enter your password";
          isValid = false;
        }
    
        setErrors(newErrors);
        return isValid;
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
    
        setLoginError(""); // Reset error on submit
        if (handleValidation()) {
          const credentials = { email, password };
    
          try {
            const response = await LoginOperation(credentials);
    
            if (response.status === "true") {
              localStorage.setItem("accessToken", response?.data?.auth?.token);
              localStorage.setItem("refreshToken", response?.data?.auth?.refreshToken);
              localStorage.setItem("name", response?.data?.user?.name);
              localStorage.setItem("userId", response?.data?.user?._id);
              localStorage.setItem('email', response?.data?.user?.email);
              localStorage.setItem("isVerified", response?.data?.user?.isVerified);
              
              navigate("/home", { state: { showPopup: false } });
            } else {
              setLoginError(response?.message || "Invalid Email or Password");
              setErrors({ email: "", password: "" });
            }
          } catch (error: any) {
            const errorData = error?.response?.data || error?.data;
                const errorIsVerified = errorData?.data?.isVerified ?? errorData?.isVerified;
                const errorMessage = errorData?.message || error?.message;
              if(errorIsVerified === false || errorIsVerified === 'false'){
                navigate('/verification');
                                }
            setLoginError(errorMessage );
            setErrors({ email: "", password: "" });
          }
        }
      };


    // Google login button logic
    const handleGoogleLogin = async () => {
        try {
            const response = await googleSignin();
            if (response && response.data?.url) {
                window.location.href = response.data.url;
            } else {
                setLoginError("Google login URL not found");
            }
        } catch (error) {
            setLoginError("An error occurred during Google login");
        }
    };

    const handleSignup = () => {
        navigate("/signup");
    };


      
    return (
        <Box
        className='gradient-background'
            style={{
                display: "flex",
                height: "100vh",
                // backgroundColor: "#1b1b2f",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    flex: 2,
                    display: { xs: "none", md: "block" },
                }}
                className='imagecontainer'
            >
                {/* <img
                    src={desktop ? 'https://showcasaai.blob.core.windows.net/applicationasset/1920.png':'https://showcasaai.blob.core.windows.net/applicationasset/LoginValentine.svg'}
                    alt="Background"
                    style={{ width: "100%", objectFit: "cover" }}
                /> */}
            </Box>

            <Box
                sx={{
                    flex: 1,
                    // backgroundColor: "#1b1b2f",
                    color: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 3,
                }}
                className="login-container"
            >
                <Box sx={{ maxWidth: 350, width: "100%" }}>
                    <Box sx={{ textAlign: "left", marginBottom: 3 }}>
                        <img
                            src={'/assets/showcasaNew.svg'}
                            alt="Logo"
                            className="showcasalogo"
                            // style={{ width: 55, height: 55, marginBottom: 15 }}
                        />
                        {/* <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 400,
                                fontSize: 32,
                                fontFamily: "ADLaM Display",
                                marginBottom: 1,
                            }}
                        >
                            Showcasaai
                        </Typography> */}
                       
                    </Box>
                     <Typography
                            variant="subtitle1"
                           className='registerTitle'
                        >
                            Sign in
                        </Typography>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Email Address"
                            type="email"
                            margin="normal"
                            error={Boolean(errors.email)} // Correct usage
                            helperText={errors.email}
                            onChange={(e) => setEmail(e.target.value)}
                            InputLabelProps={{ style: { color: "gray" } }}
                            InputProps={{
                                style: { color: "#fff", borderColor: "gray" },
                            }}
                            FormHelperTextProps={{ style: { color: '#FF5B5E' } }}
                             className="textField"
                        />
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Password"
                            type={showPassword ? "text" : "password"}
                            margin="normal"
                            error={Boolean(errors.password)}
                            helperText={errors.password}
                            onChange={(e) => setPassword(e.target.value)}
                            InputLabelProps={{ style: { color: "gray" } }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={togglePasswordVisibility} edge="end">
                                            <img src={showPassword ? '/assets/viewoff.svg' : '/assets/viewon.svg'} alt="Toggle Password Visibility" className="eye-icon" />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            FormHelperTextProps={{ style: { color: '#FF5B5E' } }}
                              className="textField"
                        />
                            {loginError && (
                          <Typography color="error" sx={{  textAlign: 'left' }} className='errorText'>
                            {loginError}
                          </Typography>
                        )}
                        

                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 2,
                            }}
                        >
                            <FormControlLabel
                                control={<Checkbox size="small" sx={{ color: "grey" }} />}
                                label={
                                    <Typography
                                        className='login-remember-label'
                                    >
                                        Remember me
                                    </Typography>
                                }
                            />
                            <Link
                                href="/forgot"
                                className='login-forgot-password'
                            >
                                Forgot Password?
                            </Link>
                        </Box>
                       

                        <Box className="signin-button">
                            <ReusableButton type="submit">
                            Sign In
                        </ReusableButton>
                        </Box>
                    </form>


                     <Box sx={{ mt: 5, textAlign: 'center' }}>
                        <Typography variant="body2" align="center" className='login-short' sx={{ mt: 2 }}>
                            Don't have an account? <span onClick={handleSignup} className='login-link'>Sign Up</span>
                        </Typography>
                        </Box>
                <Box >
                    {/* <Typography className='sigintext' gutterBottom>Sign with Google</Typography> */}
                   <Box className="login-with">
                     <IconButton onClick={handleGoogleLogin} className='google-button'>
                        <img src='/assets/Google.svg' alt="Google Logo" className='google-logo'/>
                    </IconButton>
                    {/* <IconButton onClick={()=>console.log('Apple login')} className='apple-button'>
                        <img src='/assets/Apple.svg' alt="Apple Logo" className='apple-logo'/>
                    </IconButton> */}
                   </Box>
                </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default Login;